import { CustomAction } from 'model/state';
import { FETCH_THRESHOLD_SETTINGS, FETCH_THRESHOLD_SETTINGS_SUCCESS, FETCH_THRESHOLD_SETTINGS_ERROR, UPDATE_THRESHOLD_SETTINGS, SAVE_THRESHOLD_SETTINGS,
  SAVE_THRESHOLD_SETTINGS_SUCCESS, SAVE_THRESHOLD_SETTINGS_ERROR,
  SAVE_AUTO_SHUTOFF_SETTINGS,
  FETCH_NOTIFICATION_SETTINGS, FETCH_NOTIFICATION_SETTINGS_SUCCESS,
  FETCH_NOTIFICATION_SETTINGS_ERROR,
  UPDATE_NOTIFICATION_SETTINGS_TAB,
  UPDATE_NOTIFICATION_STATE,
  SAVE_NOTIFICATION_SETTINGS,
  SAVE_NOTIFICATION_SETTINGS_SUCCESS,
  SAVE_NOTIFICATION_SETTINGS_ERROR} from 'constants/ActionTypes';
import { Location, ThresholdSettings, AlarmSeverity, Device } from 'model';
import { AlarmSettings } from 'model';

/**
 * Payload
 */
export interface SettingsPayload {
  locations?: Location[];
  settings?: ThresholdSettings;
  userId?: string;
  device?: Device;
  alarmSettings?: AlarmSettings[];
  currentTab?: AlarmSeverity;
  alarmSettingsPayload?: AlarmSettingsPayload;
  alarmId?: number;
  locationIds?: string[];
}

export interface AlarmSettingsPayload {
  smsEnabled?: boolean;
  callEnabled?: boolean;
  emailEnabled?: boolean;
  pushEnabled?: boolean;
}

/**
 * Actions
 */
export const fetchThresholdSettings = (locations: Location[]): CustomAction<SettingsPayload> => {
  return {
    type: FETCH_THRESHOLD_SETTINGS,
    payload: { locations }
  };
};

export const fetchThresholdSettingsSuccess = (settings: ThresholdSettings): CustomAction<SettingsPayload> => {
  return {
    type: FETCH_THRESHOLD_SETTINGS_SUCCESS,
    payload: { settings }
  };
};

export const fetchThresholdSettingsError = (): CustomAction<SettingsPayload> => {
  return {
    type: FETCH_THRESHOLD_SETTINGS_ERROR,
  };
};

export const updateThresholdsSettings = (settings: ThresholdSettings): CustomAction<SettingsPayload> => {
  return {
    type: UPDATE_THRESHOLD_SETTINGS,
    payload: { settings }
  };
};

export const saveThresholdSettings = (locationIds: string[], settings: ThresholdSettings): CustomAction<SettingsPayload> => {
  return {
    type: SAVE_THRESHOLD_SETTINGS,
    payload: { settings, locationIds }
  };
};

export const saveThresholdSettingsSuccess = (settings: ThresholdSettings): CustomAction<SettingsPayload> => {
  return {
    type: SAVE_THRESHOLD_SETTINGS_SUCCESS,
    payload: { settings }
  };
};

export const saveThresholdSettingsError = (): CustomAction<SettingsPayload> => {
  return {
    type: SAVE_THRESHOLD_SETTINGS_ERROR,
  };
};

export const saveAutoShutoffSettings = (locationIds: string[], settings: ThresholdSettings): CustomAction<SettingsPayload> => {
  return {
    type: SAVE_AUTO_SHUTOFF_SETTINGS,
    payload: { settings, locationIds }
  };
};

export const fetchNotificationSettings = (userId?: string, device?: Device, locationIds?: string[]): CustomAction<SettingsPayload> => {
  return {
    type: FETCH_NOTIFICATION_SETTINGS,
    payload: { userId, device, locationIds }
  };
};

export const fetchNotificationSettingsSuccess = (alarmSettings: AlarmSettings[]): CustomAction<SettingsPayload> => {
  return {
    type: FETCH_NOTIFICATION_SETTINGS_SUCCESS,
    payload: { alarmSettings }
  };
};

export const fetchNotificationSettingsError = (): CustomAction<SettingsPayload> => {
  return {
    type: FETCH_NOTIFICATION_SETTINGS_ERROR,
  };
};

export const updateNotificationSettingsTab = (currentTab: AlarmSeverity): CustomAction<SettingsPayload> => {
  return {
    type: UPDATE_NOTIFICATION_SETTINGS_TAB,
    payload: { currentTab }
  };
};

export const updateNotificationState = (alarmId: number, alarmSettingsPayload: AlarmSettingsPayload): CustomAction<SettingsPayload> => {
  return {
    type: UPDATE_NOTIFICATION_STATE,
    payload: { alarmId, alarmSettingsPayload }
  };
};

export const saveNotificationSettings = (userId?: string): CustomAction<SettingsPayload> => {
  return {
    type: SAVE_NOTIFICATION_SETTINGS,
    payload: { userId }
  };
};

export const saveNotificationSettingsSuccess = (): CustomAction<SettingsPayload> => {
  return {
    type: SAVE_NOTIFICATION_SETTINGS_SUCCESS,
  };
};

export const saveNotificationSettingsError = (): CustomAction<SettingsPayload> => {
  return {
    type: SAVE_NOTIFICATION_SETTINGS_ERROR,
  };
};